import React from 'react';

interface MobileBackdropProps {
  onClose: () => void;
}

export const MobileBackdrop: React.FC<MobileBackdropProps> = ({ onClose }) => {
  return <div className="mobile-backdrop" onClick={onClose} />;
};
